import { request } from '@/network/axios'

import { Channel, ChannelListParams } from './types.ts'

enum APIS {
  GET_HISTORY_CHANNEL_LIST = '/v1/chat/historyChannelList',
  GET_CHANNEL_DETAIL = '/v1/chat/getChannelDetail',
}

export const getHistoryChannelList = async (params: ChannelListParams) => {
  const res = request.get<Channel[]>(APIS.GET_HISTORY_CHANNEL_LIST, params)
  return res
}

export const getChannelDetail = async (channelId: string) => {
  const res = await request.get<{ channel: Channel }>(APIS.GET_CHANNEL_DETAIL, { channelId })
  return res
}
